import { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { PrinterFill, XCircleFill } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { CustomButton } from '../../../../components/CustomButton'
import apinode from '../../../../services/apinode'
import { sendErrorApiMessage } from '../../../../utils/sendErrorApiMessage'

export function ModalImprimirMassa({ isOpen, onClose }) {
  const [deposito, setDeposito] = useState('')
  const [ruaMassa, setRuaMassa] = useState({
    from: '',
    to: '',
  })
  const [predioMassa, setPredioMassa] = useState({
    from: '',
    to: '',
  })
  const [nivelMassa, setNivelMassa] = useState({
    from: '',
    to: '',
  })
  const [aptoMassa, setAptoMassa] = useState({
    from: '',
    to: '',
  })
  const [gerar, setGerar] = useState('')
  const [tipo_impressao, setTipoImpressao] = useState('')
  const [imprimir_sku, setImprimirSku] = useState(false)

  const [isPrintRequestLoading, setIsPrintRequestLoading] = useState(false)

  const isFormAddressDisabled =
    !ruaMassa.from ||
    !ruaMassa.to ||
    !predioMassa.from ||
    !predioMassa.to ||
    !nivelMassa.from ||
    !nivelMassa.to ||
    !aptoMassa.from ||
    !aptoMassa.to

  async function handlePrintLabelPerInterval() {
    try {
      setIsPrintRequestLoading(true)

      const data = {
        deposito,
        ruaMassa,
        predioMassa,
        nivelMassa,
        aptoMassa,
        gerar,
        tipo_impressao,
        imprimir_sku,
      }

      await apinode.post(
        `/wms-massive-print-label/${localStorage.idconta}`,
        data,
      )

      toast.success('Os endereços foram enviados para a fila de impressão!')
      onClose()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível imprimir em massa!')
    } finally {
      setIsPrintRequestLoading(false)
    }
  }

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modalzpl"
      centered
    >
      <Modal.Header>
        <Modal.Title>Imprimir Em Massa</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row className="mb-3">
          <Col>
            <Form.Label>Depósito</Form.Label>

            <Form.Control
              value={deposito}
              onChange={(e) => setDeposito(e.target.value)}
            />
          </Col>

          <Col>
            <Form.Label>Rua</Form.Label>

            <div
              style={{
                display: 'flex',
                gap: 10,
              }}
            >
              <Form.Control
                value={ruaMassa.from}
                onChange={(e) =>
                  setRuaMassa((prevState) => ({
                    ...prevState,
                    from: e.target.value,
                  }))
                }
              />

              <Form.Control
                value={ruaMassa.to}
                onChange={(e) =>
                  setRuaMassa((prevState) => ({
                    ...prevState,
                    to: e.target.value,
                  }))
                }
              />
            </div>
          </Col>

          <Col>
            <Form.Label>Prédio</Form.Label>

            <div
              style={{
                display: 'flex',
                gap: 10,
              }}
            >
              <Form.Control
                value={predioMassa.from}
                onChange={(e) =>
                  setPredioMassa((prevState) => ({
                    ...prevState,
                    from: e.target.value,
                  }))
                }
              />

              <Form.Control
                value={predioMassa.to}
                onChange={(e) =>
                  setPredioMassa((prevState) => ({
                    ...prevState,
                    to: e.target.value,
                  }))
                }
              />
            </div>
          </Col>

          <Col>
            <Form.Label>Nível</Form.Label>

            <div
              style={{
                display: 'flex',
                gap: 10,
              }}
            >
              <Form.Control
                value={nivelMassa.from}
                onChange={(e) =>
                  setNivelMassa((prevState) => ({
                    ...prevState,
                    from: e.target.value,
                  }))
                }
              />

              <Form.Control
                value={nivelMassa.to}
                onChange={(e) =>
                  setNivelMassa((prevState) => ({
                    ...prevState,
                    to: e.target.value,
                  }))
                }
              />
            </div>
          </Col>

          <Col>
            <Form.Label>Apartamento</Form.Label>

            <div
              style={{
                display: 'flex',
                gap: 10,
              }}
            >
              <Form.Control
                value={aptoMassa.from}
                onChange={(e) =>
                  setAptoMassa((prevState) => ({
                    ...prevState,
                    from: e.target.value,
                  }))
                }
              />

              <Form.Control
                value={aptoMassa.to}
                onChange={(e) =>
                  setAptoMassa((prevState) => ({
                    ...prevState,
                    to: e.target.value,
                  }))
                }
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col xs={3}>
            <Form.Label>Gerar</Form.Label>
            <Form.Select
              value={gerar}
              onChange={(e) => setGerar(e.target.value)}
            >
              <option value="todos">Todos</option>
              <option value="pares">Pares</option>
              <option value="impares">Ímpares</option>
            </Form.Select>
          </Col>

          <Col xs={3}>
            <Form.Label>Tipo de Impressão</Form.Label>
            <Form.Select
              value={tipo_impressao}
              onChange={(e) => setTipoImpressao(e.target.value)}
            >
              <option value="">Sem Figura</option>
              <option value="S">Superior</option>
              <option value="I">Inferior</option>
              <option value="E">Esquerda</option>
              <option value="D">Direita</option>
            </Form.Select>
          </Col>

          <Col xs={3}>
            <Form.Label>Imprimir SKU</Form.Label>
            <Form.Check
              checked={imprimir_sku}
              onClick={(e) => {
                if (e.target.checked) {
                  setImprimirSku(true)
                } else {
                  setImprimirSku(false)
                }
              }}
            />
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CustomButton
          title="Imprimir"
          color="#229954"
          onClick={handlePrintLabelPerInterval}
          isLoading={isPrintRequestLoading}
          isDisabled={isFormAddressDisabled || isPrintRequestLoading}
          isLoadingText="Imprimindo..."
        >
          <PrinterFill />
        </CustomButton>

        <CustomButton
          title="Cancelar"
          color="#b03a2e"
          isDisabled={isPrintRequestLoading}
          onClick={onClose}
        >
          <XCircleFill />
        </CustomButton>
      </Modal.Footer>
    </Modal>
  )
}
